import React, { useState, useEffect } from 'react';

const DEFAULT_PREFIX = '/bunny.jpg';

const DynamicImageProcessing = ({ block }) => {
  const [active, setActive] = useState(0);
  const [txtRotations, addRotation] = useState({});

  const toggleTabs = e => {
    let index;
    if (e.target.id) {
      index = parseInt(e.target.id, 0);
    } else {
      index = parseInt(e.target.parentElement.parentElement.id, 0);
    }

    if (index !== active) {
      setActive(index);
      cancelTxtRotations();
      startRotation(index);
    }
  };

  function cancelTxtRotations() {
    for (const [key, txtRotation] of Object.entries(txtRotations)) {
      txtRotation.stop();
      delete txtRotations[key];
    }

    document.querySelector('.bunny-img').style.transform = '';
  }

  function startRotation(index) {
    let elements = document.getElementsByClassName('txt-rotate');
    let toRotate = elements[index].getAttribute('data-rotate');
    let period = elements[index].getAttribute('data-period');

    if (toRotate && toRotate.length > 0) {
      addRotation({
        [index]: new TxtRotate(
          elements[index],
          JSON.parse(toRotate),
          period,
          index
        ),
      });
    }
  }

  String.prototype.insert = function (index, string) {
    if (index > 0) {
      return this.substring(0, index) + string + this.substr(index);
    }
    return string + this;
  };

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  let TxtRotate = function (el, toRotate, period, index) {
    const imgElement = document.querySelector('.anim-' + index + ' .bunny-img');
    this.timer = null;
    this.index = index;
    this.src = imgElement?.getAttribute('data-src');
    this.widthIndex = imgElement?.getAttribute('data-width-index');
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = '';
    this.start();
    this.isDeleting = false;
  };

  TxtRotate.prototype.stop = function () {
    clearInterval(this.timer);
  };

  TxtRotate.prototype.start = function () {
    if (this.toRotate.length === 0) {
      console.error('Missing animation values.');
      return;
    }

    let i = this.loopNum % this.toRotate.length;
    let fullTxt = this.toRotate[i];
    let rotationsNum = this.toRotate.length;

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';
    applyStyle(this.index);

    let that = this;
    let delta = 150 - Math.random() * 100;

    if (this.isDeleting) delta /= 3;

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;

      let next = (this.loopNum + 1) % this.toRotate.length;
      let starts = this.toRotate[next].lastIndexOf(fullTxt, 0) === 0;

      if (starts) {
        this.isDeleting = false;
        this.loopNum++;
        onTextAnimationDeleted(
          this.index,
          this.src,
          rotationsNum,
          this.widthIndex
        );
      }

      onTextAnimationFinished(
        this.index,
        this.src,
        this.toRotate,
        this.widthIndex
      );
      applyStyle(this.index);
    } else if (this.isDeleting && this.txt === '') {
      onTextAnimationDeleted(
        this.index,
        this.src,
        rotationsNum,
        this.widthIndex
      );
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    this.timer = setTimeout(function () {
      that.start();
    }, delta);
  };

  let animationCounter = 0;
  function onTextAnimationFinished(index, src, toRotate, widthIndex) {
    const element = document.querySelector('.anim-' + index + ' .bunny-img');
    if (!element) {
      return;
    }

    if (widthIndex !== null) {
      if (animationCounter === Number(widthIndex)) {
        element.style.transform = 'scale(1.05)';
      } else {
        element.src = src + toRotate[animationCounter];
      }
    } else {
      element.src = src + toRotate[animationCounter];
    }

    animationCounter++;
  }

  let animationDeletedCounter = 0;
  function onTextAnimationDeleted(index, src, last, widthIndex) {
    const element = document.querySelector('.anim-' + index + ' .bunny-img');
    if (!element) {
      return;
    }

    if (animationDeletedCounter === last - 1) {
      element.src = src;

      if (widthIndex !== null) {
        element.style.transform = '';
      }
    }

    // Resetter
    if (animationDeletedCounter === last) {
      animationDeletedCounter = 0;
      animationCounter = 0;
    }

    animationDeletedCounter++;
  }

  function applyStyle(index) {
    const element = document.querySelector('.anim-' + index + ' .wrap');
    if (!element) {
      return;
    }

    let html = element.innerHTML;
    if (!html) {
      return;
    }

    html = replaceAll(html, '&amp;', '&');

    let inserted = false;
    for (let i = 0; i < html.length; i++) {
      let c = html[i];
      if (c === '=') {
        html = html.insert(i + 1, '<strong>');
        inserted = true;
      }
      if (c === '&' && inserted) {
        html = html.insert(i, '</strong>');
        inserted = false;
      }
    }

    if (inserted) {
      html += '</strong>';
    }

    element.innerHTML = html;
  }

  useEffect(() => {
    startRotation(0);
  }, []);

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-5'>
            <ul className='tabs-header'>
              {block.tab_list.map((tab, index) => {
                return (
                  <li
                    key={index}
                    className={`tab-title ${active === index ? 'is-active' : ''}`}
                    onClick={toggleTabs}
                    active={`${active === index}`}
                    id={index}
                  >
                    {tab.tab_icon && (
                      <div className='image'>
                        <img
                          src={tab.tab_icon}
                          alt={tab.tab_title}
                          title={tab.tab_title}
                        />
                      </div>
                    )}
                    {tab.tab_title && tab.tab_title}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className='col-lg-7'>
            <div className='tabs-wr'>
              {block.tab_list.map((tab, index) => {
                let dataRotate = [];
                let rotateValues = '';
                let widthIndex;
                const tabFileName = tab.tab_base_text || DEFAULT_PREFIX;

                tab.values.forEach((e, i) => {
                  if (e.value.includes('width')) {
                    widthIndex = i;
                  }

                  rotateValues = rotateValues.replace(/"/g, '');
                  rotateValues = '"' + rotateValues + '&' + e.value + '"';
                  dataRotate.push(rotateValues);
                });

                return (
                  <div
                    key={index}
                    className={`tab-content ${active === index ? 'is-active' : ''}`}
                    active={`${active === index}`}
                    id={index}
                  >
                    <div
                      className={`bunny-image-transformation-box anim-${index}`}
                    >
                      <div className={`bunny-image-container`}>
                        <img
                          className={`bunny-img ${typeof widthIndex !== 'undefined' ? 'scale' : ''}`}
                          src={`${tab.image_url}?width=560`}
                          data-width-index={widthIndex}
                          data-src={`${typeof widthIndex !== 'undefined' ? tab.image_url + '?' : tab.image_url + '?width=560'}`}
                          alt={tab.tab_title}
                          title={tab.tab_title}
                        />
                      </div>
                      <div className='transform-text-box'>
                        <span className='file-name'>{tabFileName}</span>
                        <span
                          className='txt-rotate'
                          data-period={block.text_delay}
                          data-rotate={`[${dataRotate}]`}
                        ></span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DynamicImageProcessing;
